import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import { get, post } from 'api/requests';

import { AppThunk } from 'store/types';
import { IParamsReq } from 'types';
import { CallApartAllocated } from 'pages/Calls/ApartmentsCalls/types';

interface CallsStore {
  list: CallApartAllocated[];
  loading: boolean;
  count: number;
}

const initialState: CallsStore = {
  list: [],
  loading: false,
  count: 0,
};

const reset: CaseReducer<CallsStore> = () => initialState;

const loading: CaseReducer<CallsStore, PayloadAction<boolean>> = (state, action) => {
  state.loading = action.payload;
};

const count: CaseReducer<CallsStore, PayloadAction<number>> = (state, action) => {
  state.count = action.payload;
};

const list: CaseReducer<CallsStore, PayloadAction<CallApartAllocated[]>> = (state, action) => {
  state.list = action.payload;
};

export const allocatedSlice = createSlice({
  name: 'calls_apartments_allocated',
  initialState,
  reducers: {
    reset,
    loading,
    list,
    count,
  },
});

const {
  reset: setReset,
  loading: setLoading,
  list: setCalls,
  count: setCallsCount,
} = allocatedSlice.actions;

export { setReset };

export const getApartmentsAllocatedCalls =
  (params: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<Responce>('/api/standards/placements/on_view_placements/', { ...params })
      .then(({ data }) => {
        const { count, results } = data;
        dispatch(setCalls(results));
        dispatch(setCallsCount(count));
      })
      .finally(() => dispatch(setLoading(false)));
  };

export const sendAllocatedExcel = (reqData: IParamsReq): void => {
  post('/api/standards/placements/on_view_placements/excel/', reqData);
};

type Responce = {
  count: number;
  results: CallApartAllocated[];
};
